(function () {
    'use strict';

    function phaseDrawSchedule(workflowStateService, scrollingService, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/phaseDrawSchedule.html',
            scope: {
                drawScheduleData: '=',
                parentData: '=',
                removeDocument: '&',
                canDelete: '='
            },
            link: function (scope, element, attrs) {
                scope.workflowData = workflowStateService.get();

                scope.drawScheduleData.Items.forEach(function (item) {
                    item.DatePickerIsOpen = false;
                    item.DrawDate = new Date(item.DrawDate);
                });

                scope.updateDrawSchedule = function () {
                    if (scope.DrawScheduleForm.$valid) {
                        workflowStateService.syncDrawSchedule(scope.parentData, scope.drawScheduleData);
                    }
                }

                scope.addDrawScheduleItem = function () {
                    scope.drawScheduleData.Items.push({ DatePickerIsOpen: false });
                }

                scope.removeDrawScheduleItem = function (index) {
                    scope.drawScheduleData.Items[index].IsRemoved = true;
                    // push to end
                    scope.drawScheduleData.Items.push(scope.drawScheduleData.Items.splice(index, 1)[0]);
                    workflowStateService.syncDrawSchedule(scope.parentData, scope.drawScheduleData);
                }

                scope.openDatepicker = function (event, index) {
                    event.preventDefault();
                    event.stopPropagation();
                    scope.drawScheduleData.Items[index].DatePickerIsOpen = true;
                };

                scope.phaseIndex = (scope.parentData.Index || scope.parentData.Index === 0)
                    ? scope.parentData.Index + 1 : undefined;

                scope.toggleItem = function (item) {
                    if (item.Access.ShowPartners || item.Access.Notes) {
                        item.open = !item.open;
                    }

                    scrollingService.scrollTo(attrs.scrollToElementId + (item.open ? "_expanded" : ""),
                        item.open ? 0 : 250, 0, 0);

                    $rootScope.$emit('containerVisibilityChange',
                        {
                            containerName: scope.documentData.Path,
                            isVisible: item.open
                        });
                }

                scope.onNoteAdded = function () {
                    scope.noteCount += 1;
                }

                scope.onNoteRemoved = function (noteId) {
                    var noteToRemoveIndex = scope.drawScheduleData.ProjectUnderwritingNotes.findIndex(function (note) {
                        return note.NoteId === noteId;
                    });

                    if (noteToRemoveIndex !== -1) {
                        scope.drawScheduleData.ProjectUnderwritingNotes.splice(noteToRemoveIndex, 1);
                    }
                    scope.noteCount -= 1;
                }
            }
        };
    }

    phaseDrawSchedule.$inject = ['workflowStateService', 'scrollingService', '$rootScope'];

    angular.module('ecap.workflow').directive('phaseDrawSchedule', phaseDrawSchedule);
})();
